import { TextField } from '@material-ui/core';
import { useUnsafeTranslation } from '../../i18next';
import { InlineLoader } from '../Loader';

export const InputFieldLoader = ({
  label,
  fullWidth
}: {
  label?: string;
  fullWidth?: boolean;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <TextField
      value=""
      onChange={() => {}}
      label={label}
      fullWidth={fullWidth}
      placeholder={`${t('Loading')}...`}
      InputProps={{ endAdornment: <InlineLoader size={12} /> }}
    />
  );
};
